import { Component, Input, SimpleChanges, ViewChildren, QueryList, ElementRef, numberAttribute } from '@angular/core';
import { faAngleUp, faArrowLeft, faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ArticleService } from './../../core/services/articles/article.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth/auth.service';

interface TransformedObject {
    [key: string]: string;
}

@Component({
    selector: 'app-article',
    templateUrl: './article.component.html',
    styleUrls: ['./article.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state(
                'collapsed',
                style({
                    height: '42px', // Set initial collapsed height
                    overflow: 'hidden',
                }),
            ),
            state(
                'expanded',
                style({
                    minHeight: '5vh',
                    maxHeight: '50vh',
                    // height:'250px',
                    //overflow: 'hidden',
                    overflowY: 'auto',
                }),
            ),
            transition('collapsed => expanded', [
                animate('300ms ease-out'), // Adjust duration and easing as needed
            ]),
            transition('expanded => collapsed', [
                animate('300ms ease-out'), // Adjust duration and easing as needed
            ]),
        ]),
    ],
})
export class ArticleComponent {
    showViewMoreButton: boolean = true;
    faAngleUp = faAngleUp;
    faArrowLeft = faArrowLeft;
    faAngleRight = faAngleRight;
    faAngleDown = faAngleDown;
    currentSelectedArticleId: any;
    articlesLongStoryData: any;
    currentArticleId: any;
    previousArticleId: any;
    currentClickedArticleId: any;
    //articleNotAvailable = false;

    @Input() loading: boolean = true;
    @Input() articleNotAvailable = false;

    //getting data from parent
    @Input() articles: any;
    @Input() sentenceIds: any;
    isClickBack = false;
    // @Input() articlesLongStoryData: any;

    openArticleIndex: number | null = null;
    //loading: boolean = true; // true to show loading skeleton
    currentIndex: number = 0;
    isContentExpanded: Array<boolean> = [];
    hideAfterLongStoryOpenInMobile: boolean = false;
    private disableHighlight: Subscription;
    private articleNetworkResetSubject: Subscription;
    private findMoreArticleClicked: Subscription;
    private CallFromSocketForGyanStatus: Subscription;
    receivedSentenceIds: any;
    gyanType: any;

    @ViewChildren('articleContent') contentElements!: QueryList<ElementRef>;
    isMobile = false;
    selectedParaIndex: any;

    constructor(
        private articleService: ArticleService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private authService: AuthService,
    ) {
        // calling subject to toggle off after find more articles
        this.findMoreArticleClicked = this.commonServiceService.findMoreArticleClick$.subscribe((value) => {
            if (value) {
                for (let i = 0; i < this.isContentExpanded.length; i++) {
                    this.isContentExpanded[i] = true;
                }
                //this.isContentExpanded[0] = true;
            }
            //alert('ada2');
        });

        //this subject is to disable the highlight once we go back to MDS page from longstory page
        this.disableHighlight = this.commonServiceService.disablehighlight$.subscribe((value) => {
            if (value) {
                this.currentSelectedArticleId = '';
                this.selectedParaIndex = null;
                this.currentArticleId = null;
                //  this.isContentExpanded[0] = true;
            }
        });

        this.articleNetworkResetSubject = this.commonServiceService.articleNetworkResetSubject$.subscribe((data) => {
            if (data) {
                this.currentClickedArticleId = '';
                this.selectedParaIndex = null;
                this.currentArticleId = null;
                //this.isContentExpanded[0] = true;
            }
        });

        this.CallFromSocketForGyanStatus = this.commonServiceService.CallFromSocketForGyanStatus$.subscribe((value) => {
            console.log('CallFromSocketForGyanStatus >> value', value);
            console.log(value);
            if (typeof value !== 'boolean') {
                const gyanDetails = this.localStorageService.getItem('gyanData');
                if (gyanDetails) {
                    console.log('the gyandetail', gyanDetails);
                    console.log('the gyandetail', gyanDetails);

                    if (value.data.id === gyanDetails.gyanId) {
                        const gyanData = {
                            gyanName: gyanDetails.gyanName,
                            gyanId: gyanDetails.gyanId,
                            gyanType: gyanDetails.gyanType,
                            gyanCreatedNow: gyanDetails.gyanCreatedNow,
                            gyanStatus: value.data.gyanStatus,
                        };
                        this.localStorageService.setItem('gyanData', gyanData);
                    }
                }
                // if (gyanDetails) {
                //     console.log('the gyandetail', gyanDetails);
                //     if (gyanDetails.gyanId === value.data.id) {
                //         const gyanData = {
                //             gyanName: gyanDetails.gyanName,
                //             gyanId: gyanDetails.gyanId,
                //             gyanType: gyanDetails.gyanType,
                //             gyanCreatedNow: gyanDetails.gyanCreatedNow,
                //             gyanStatus: value.data.gyanStatus,
                //         };
                //         this.localStorageService.setItem('gyanData', gyanData);
                //     }
                // }
                if (value.data?.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                    console.log('loading >> 133');
                    this.loading = true;
                    console.log('articleNotAvailable >> 134');
                    // this.articleNotAvailable = true;
                }
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        const gyanData = this.localStorageService.getItem('gyanData');
        if (changes['sentenceIds']) this.receivedSentenceIds = changes['sentenceIds']['currentValue'];
        console.log('the changes for the status', changes);
        // if (changes['articleNotAvailable']) this.articleNotAvailable = changes['articleNotAvailable']['currentValue'];

        //below logic is added for GA-2904
        if (gyanData?.gyanStatus == 'FINISHED' || gyanData?.gyanStatus == 'FAIL' || gyanData?.gyanStatus == '9' || gyanData?.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
            if (changes['articleNotAvailable']) console.log('articleNotAvailable 149');
            this.articleNotAvailable = changes['articleNotAvailable']['currentValue'];
            if (this.articles.length === 0) {
                this.articleNotAvailable = true;
            }
        } else {
            if (changes['articles']) this.articles = changes['articles']['currentValue'];
            if (this.articles.length === 0) console.log('articleNotAvailable 154');
            this.articleNotAvailable = false;
        }
        // if (this.isMobile) {
        this.setToggleFocus();

        //}

        //till here GA-2904

        // if(changes['articles']) this.articles = changes['articles']['currentValue'];

        if (gyanData.clickbackfromgyan === 'yes') {
            this.isClickBack = true;
        } else {
            this.isClickBack = false;
        }
        //   console.log('this.receivedSentenceIds', this.receivedSentenceIds);
    }
    setToggleFocus() {
        const articleClickIndex = this.localStorageService.getItem('articleClickIndex');
        if (articleClickIndex !== undefined && articleClickIndex > -1) {
            this.isContentExpanded[Number.parseInt(articleClickIndex)] = true;
            // const element = document.getElementById('article-toggle-' + articleClickIndex);
            // if (element) {
            //     element.focus();
            //     element.scrollIntoView({
            //         behavior: 'smooth', // Smooth scrolling
            //         block: 'start', // Scroll to the top of the element
            //         inline: 'nearest', // Align the element to the nearest edge
            //     });
            // }
        }
    }

    loadArticleLongStory(articleId: any, articleRecordId: any) {
        this.commonServiceService.setRefreshAdvancedQueries(false);
        this.currentArticleId = articleId;
        this.currentSelectedArticleId = articleRecordId;
        this.currentClickedArticleId = '';
        this.hideAfterLongStoryOpenInMobile = true;

        console.log('this.previousArticleSelectedId', this.previousArticleId);
        console.log('this.currentSelectedArticleId)', this.currentArticleId);

        // subject is call to load article panel from main panel.
        this.commonServiceService.setArticleLongStory(true);
        const gyanData = this.localStorageService.getItem('gyanData');

        if (gyanData.gyanType === 'gyan') {
            this.callLongStoryForAdvancedQueries(articleId, articleRecordId);
        } else {
            if (this.previousArticleId !== this.currentArticleId) {
                //for new article clicked sending empty data
                const Obj = {
                    longStoryData: {},
                };
                //        console.log(Obj);
                this.commonServiceService.articleLongStoryDataActual.next(Obj);
                this.loadArticleLongStoryApi(articleId, articleRecordId); //calling api to get current article data

                this.previousArticleId = this.currentArticleId;
            } else {
                const longStoryData = this.getValueForId(articleRecordId);
                //sending longstory data from subject
                const longStoryDataObj = {
                    articleRecordId: articleRecordId,
                    longStoryData: longStoryData,
                };
                //call subject to pass final data to article long story component.
                this.commonServiceService.articleLongStoryDataActual.next(longStoryDataObj);
            }
        }

        //this is making false when loaded
        // const obj = {
        //     callMDS: false,
        //     callArticles: false,
        // };
        // this.commonServiceService.setPreviousGyanClick(obj);
    }

    callLongStoryForAdvancedQueries(articleId: any, articleRecordId: any) {
        const payload = {
            atmid: articleId,
            type: 'C',
            paraId: articleRecordId,
        };
        this.articleService.getArticleLongStoryForAdvanceQuery(payload).subscribe({
            next: (response: HttpResponse<any>) => {
                if (response.status == 200) {
                    console.log(response);
                    const responseBody = response.body;
                    this.articlesLongStoryData = responseBody.lhsRhsSummary.rhs;
                    const longStoryDataObj = {
                        articleRecordId: articleRecordId,
                        longStoryData: this.articlesLongStoryData,
                    };
                    //call subject to pass final data to article long story component.
                    this.commonServiceService.articleLongStoryDataActual.next(longStoryDataObj);
                } else {
                    if (response.status == 204) {
                        //handle the summary not available
                    }
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log(error);
            },
            complete: () => {
                //    console.log('Article LongStory get successfully');
            },
        });
    }

    getValueForId(id: string): string | undefined {
        for (const key of Object.keys(this.articlesLongStoryData)) {
            if (key.includes(id)) {
                return this.articlesLongStoryData[key];
            }
        }
        return undefined;
    }

    loadArticleNetworkGraph(articleId: number, articleTitle: string, networkRootId: any) {
        console.log('article Netowrk Graph CLicked', articleId);
        this.currentClickedArticleId = articleId;
        this.hideAfterLongStoryOpenInMobile = true;
        this.selectedParaIndex = null;
        this.currentSelectedArticleId = null;
        const ntwrkObj = {
            articleId: articleId,
            articleTitle: articleTitle,
            networkRootId: networkRootId,
        };
        this.commonServiceService.articleNetworkSubject.next(ntwrkObj);
    }

    // loadArticleNetworkGraphForAdvanceQuery(articleId: number, articleTitle: string) {
    //     //    console.log('article Netowrk Graph CLicked');
    //     this.currentClickedArticleId = articleId;
    //     this.hideAfterLongStoryOpenInMobile = true;
    //     const ntwrkObj = {
    //         articleId: articleId,
    //         articleTitle: articleTitle,
    //     };
    //     this.commonServiceService.articleNetworkSubject.next(ntwrkObj);
    // }

    ngOnInit() {
        this.loadArticles();
        this.checkWidth();
        console.log('this.articleNotAvailable', this.articleNotAvailable);
        console.log('this.loading', this.loading);
        const gyanData = this.localStorageService.getItem('gyanData');

        this.gyanType = gyanData.gyanType;
        // if (this.articles.length === 0) {
        //     this.articleNotAvailable = true;
        //     console.log(this.articleNotAvailable);
        //     this.loading = true;
        // }
    }

    expandCollapseIconClicked(summaryItem: any) {
        // event.stopPropagation();
        summaryItem.isExpanded = !summaryItem.isExpanded;
    }

    loadArticles() {
        console.log('loadArticles >> this.articles');
        console.log(this.articles);
        const delay = 100; // Initial delay
        if (this.articles.length > 0) {
            console.log('articleNotAvailable 302');
            this.articleNotAvailable = false;
        } else {
            if (!this.loading) {
                this.articleNotAvailable = true;
            }
        }
        for (let i = 0; i < this.articles.length; i++) {
            setTimeout(
                () => {
                    // Load the next article after the specified delay
                    this.currentIndex = i + 1;

                    // If this is the last article, set loading to false
                    if (i === this.articles.length - 1) {
                        console.log('loading >> 314');
                        this.loading = false;
                    }
                },
                delay * (i + 1),
            ); // Multiply the delay by the index to loading
        }
    }

    toggleContent(index: number, articleId: any) {
        // Close all panels when the clicked new one
        for (let i = 0; i < this.isContentExpanded.length; i++) {
            if (i !== index) {
                this.isContentExpanded[i] = false;
                if (this.currentSelectedArticleId !== articleId) {
                    this.selectedParaIndex = null;
                    this.currentArticleId = null; // Reset highlight
                }
            }
        }
        this.isContentExpanded[index] = !this.isContentExpanded[index];
        if (this.isContentExpanded[index]) {
            this.localStorageService.setItem('articleClickIndex', index);
        } else {
            this.localStorageService.removeItem('articleClickIndex');
        }
        // Reset scroll position of the previously opened content
        this.contentElements.forEach((element, i) => {
            //if (i !== index) {
            element.nativeElement.scrollTop = 0;
            //}
        });
    }

    showArticleList() {
        this.hideAfterLongStoryOpenInMobile = false;
    }

    loadArticleLongStoryApi(articleId: any, articleRecordId: any) {
        console.log('loadArticleLongStoryApi Called', articleId, articleRecordId);
        const gyanData = this.localStorageService.getItem('gyanData');

        if (gyanData.gyanType === 'rapid') {
            const personId = this.authService.getPersonId();
            this.articleService.getArticleLongStory(personId, articleId).subscribe({
                next: (response: HttpResponse<any>) => {
                    if (response.status == 200) {
                        console.log(response);
                        const responseBody = response.body;
                        this.articlesLongStoryData = responseBody.data;

                        const longStoryData = this.getValueForId(articleRecordId);
                        //sending longstory data from subject
                        const longStoryDataObj = {
                            articleRecordId: articleRecordId,
                            longStoryData: longStoryData,
                        };
                        //call subject to pass final data to article long story component.
                        this.commonServiceService.articleLongStoryDataActual.next(longStoryDataObj);
                    } else {
                        if (response.status == 204) {
                            //handle the summary not available
                        }
                    }
                },
                error: (error: HttpErrorResponse) => {
                    console.log(error);
                },
                complete: () => {
                    //    console.log('Article LongStory get successfully');
                },
            });
        }
    }

    isSentenceHighlighted(sentenceRecordId: string): boolean {
        if (this.sentenceIds) return this.sentenceIds.includes(sentenceRecordId);
        else return false;
    }

    checkWidth() {
        const width = window.innerWidth;
        //console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    ngOnDestroy() {
        this.disableHighlight.unsubscribe();
        this.articleNetworkResetSubject.unsubscribe();
        this.findMoreArticleClicked.unsubscribe();
        this.CallFromSocketForGyanStatus.unsubscribe();
    }
}
